export type ZoneKey =
  | "Noroeste (GAM)"
  | "Noreste (GAM)"
  | "Suroeste (GAM)"
  | "Sureste (GAM)"
  | "Norte (Fuera del GAM)"
  | "Sur (Fuera del GAM)"
  | "Oeste (Fuera del GAM)"
  | "Este (Fuera del GAM)"
  | "GAM"
  | "Zona Desconocida"

export interface District {
  name: string
  code: string
}

export interface Canton {
  name: string
  code: string
  districts: District[]
}

export interface Province {
  name: string
  code: string
  flag: string
  cantons: Canton[]
}

export const provinces: Province[] = [
  {
    name: "Alajuela",
    code: "2",
    flag: "/assets/images/flags/Alajuela.png",
    cantons: [
      {
        name: "Alajuela",
        code: "201",
        districts: [
          { name: "Alajuela", code: "20101" },
          { name: "San José", code: "20102" },
          { name: "Carrizal", code: "20103" },
          { name: "San Antonio", code: "20104" },
          { name: "Guácima", code: "20105" },
          { name: "San Isidro", code: "20106" },
          { name: "Sabanilla", code: "20107" },
          { name: "San Rafael", code: "20108" },
          { name: "Río Segundo", code: "20109" },
          { name: "Desamparados", code: "20110" },
          { name: "Turrúcares", code: "20111" },
          { name: "Tambor", code: "20112" },
          { name: "Garita", code: "20113" },
          { name: "Sarapiquí", code: "20114" },
        ],
      },
      {
        name: "Atenas",
        code: "205",
        districts: [
          { name: "Atenas", code: "20501" },
          { name: "Jesús", code: "20502" },
          { name: "Mercedes", code: "20503" },
          { name: "San Isidro", code: "20504" },
          { name: "Concepción", code: "20505" },
          { name: "San José", code: "20506" },
          { name: "Santa Eulalia", code: "20507" },
          { name: "Escobal", code: "20508" },
        ],
      },
      {
        name: "Grecia",
        code: "203",
        districts: [
          { name: "Grecia", code: "20301" },
          { name: "San Isidro", code: "20302" },
          { name: "San José", code: "20303" },
          { name: "San Roque", code: "20304" },
          { name: "Tacares", code: "20305" },
          { name: "Río Cuarto", code: "20306" },
          { name: "Puente de Piedra", code: "20307" },
          { name: "Bolívar", code: "20308" },
        ],
      },
      {
        name: "Guatuso",
        code: "215",
        districts: [
          { name: "San Rafael", code: "21501" },
          { name: "Buenavista", code: "21502" },
          { name: "Cote", code: "21503" },
          { name: "Katira", code: "21504" },
        ],
      },
      {
        name: "Los Chiles",
        code: "214",
        districts: [
          { name: "Los Chiles", code: "21401" },
          { name: "Caño Negro", code: "21402" },
          { name: "El Amparo", code: "21403" },
          { name: "San Jorge", code: "21404" },
        ],
      },
      {
        name: "Naranjo",
        code: "206",
        districts: [
          { name: "Naranjo", code: "20601" },
          { name: "San Miguel", code: "20602" },
          { name: "San José", code: "20603" },
          { name: "Cirrí Sur", code: "20604" },
          { name: "San Jerónimo", code: "20605" },
          { name: "San Juan", code: "20606" },
          { name: "El Rosario", code: "20607" },
          { name: "Palmitos", code: "20608" },
        ],
      },
      {
        name: "Orotina",
        code: "209",
        districts: [
          { name: "Orotina", code: "20901" },
          { name: "El Mastate", code: "20902" },
          { name: "Hacienda Vieja", code: "20903" },
          { name: "Coyolar", code: "20904" },
          { name: "La Ceiba", code: "20905" },
        ],
      },
      {
        name: "Palmares",
        code: "207",
        districts: [
          { name: "Palmares", code: "20701" },
          { name: "Zaragoza", code: "20702" },
          { name: "Buenos Aires", code: "20703" },
          { name: "Santiago", code: "20704" },
          { name: "Candelaria", code: "20705" },
          { name: "Esquipulas", code: "20706" },
          { name: "La Granja", code: "20707" },
        ],
      },
      {
        name: "Poás",
        code: "208",
        districts: [
          { name: "San Pedro", code: "20801" },
          { name: "San Juan", code: "20802" },
          { name: "San Rafael", code: "20803" },
          { name: "Carrillos", code: "20804" },
          { name: "Sabana Redonda", code: "20805" },
        ],
      },
      {
        name: "Río Cuarto",
        code: "216",
        districts: [
          { name: "Río Cuarto", code: "21601" },
          { name: "Santa Rita", code: "21602" },
          { name: "Santa Isabel", code: "21603" },
        ],
      },
      {
        name: "San Carlos",
        code: "210",
        districts: [
          { name: "Quesada", code: "21001" },
          { name: "Florencia", code: "21002" },
          { name: "Buenavista", code: "21003" },
          { name: "Aguas Zarcas", code: "21004" },
          { name: "Venecia", code: "21005" },
          { name: "Pital", code: "21006" },
          { name: "La Fortuna", code: "21007" },
          { name: "La Tigra", code: "21008" },
          { name: "La Palmera", code: "21009" },
          { name: "Venado", code: "21010" },
          { name: "Cutris", code: "21011" },
          { name: "Monterrey", code: "21012" },
          { name: "Pocosol", code: "21013" },
        ],
      },
      {
        name: "San Mateo",
        code: "204",
        districts: [
          { name: "San Mateo", code: "20401" },
          { name: "Desmonte", code: "20402" },
          { name: "Jesús María", code: "20403" },
          { name: "Labrador", code: "20404" },
        ],
      },
      {
        name: "San Ramón",
        code: "202",
        districts: [
          { name: "San Ramón", code: "20201" },
          { name: "Santiago", code: "20202" },
          { name: "San Juan", code: "20203" },
          { name: "Piedades Norte", code: "20204" },
          { name: "Piedades Sur", code: "20205" },
          { name: "San Rafael", code: "20206" },
          { name: "San Isidro", code: "20207" },
          { name: "Ángeles", code: "20208" },
          { name: "Alfaro", code: "20209" },
          { name: "Volio", code: "20210" },
          { name: "Concepción", code: "20211" },
          { name: "Zapotal", code: "20212" },
          { name: "Peñas Blancas", code: "20213" },
          { name: "San Lorenzo", code: "20214" },
        ],
      },
      {
        name: "Upala",
        code: "213",
        districts: [
          { name: "Upala", code: "21301" },
          { name: "Aguas Claras", code: "21302" },
          { name: "San José", code: "21303" },
          { name: "Bijagua", code: "21304" },
          { name: "Delicias", code: "21305" },
          { name: "Dos Ríos", code: "21306" },
          { name: "Yolillal", code: "21307" },
          { name: "Canalete", code: "21308" },
        ],
      },
      {
        name: "Valverde Vega",
        code: "212",
        districts: [
          { name: "Sarchí Norte", code: "21201" },
          { name: "Sarchí Sur", code: "21202" },
          { name: "Toro Amarillo", code: "21203" },
          { name: "San Pedro", code: "21204" },
          { name: "Rodríguez", code: "21205" },
        ],
      },
      {
        name: "Zarcero",
        code: "211",
        districts: [
          { name: "Zarcero", code: "21101" },
          { name: "Laguna", code: "21102" },
          { name: "Tapesco", code: "21103" },
          { name: "Guadalupe", code: "21104" },
          { name: "Palmira", code: "21105" },
          { name: "Zapote", code: "21106" },
          { name: "Brisas", code: "21107" },
        ],
      },
    ],
  },
  {
    name: "Cartago",
    code: "3",
    flag: "/assets/images/flags/Cartago.png",
    cantons: [
      {
        name: "Alvarado",
        code: "306",
        districts: [
          { name: "Pacayas", code: "30601" },
          { name: "Cervantes", code: "30602" },
          { name: "Capellades", code: "30603" },
        ],
      },
      {
        name: "Cartago",
        code: "301",
        districts: [
          { name: "Oriental", code: "30101" },
          { name: "Occidental", code: "30102" },
          { name: "Carmen", code: "30103" },
          { name: "San Nicolás", code: "30104" },
          { name: "Aguacaliente", code: "30105" },
          { name: "Guadalupe", code: "30106" },
          { name: "Corralillo", code: "30107" },
          { name: "Tierra Blanca", code: "30108" },
          { name: "Dulce Nombre", code: "30109" },
          { name: "Llano Grande", code: "30110" },
          { name: "Quebradilla", code: "30111" },
        ],
      },
      {
        name: "El Guarco",
        code: "308",
        districts: [
          { name: "El Tejar", code: "30801" },
          { name: "San Isidro", code: "30802" },
          { name: "Tobosi", code: "30803" },
          { name: "Patio de Agua", code: "30804" },
        ],
      },
      {
        name: "Jiménez",
        code: "304",
        districts: [
          { name: "Juan Viñas", code: "30401" },
          { name: "Tucurrique", code: "30402" },
          { name: "Pejibaye", code: "30403" },
        ],
      },
      {
        name: "La Unión",
        code: "303",
        districts: [
          { name: "Tres Ríos", code: "30301" },
          { name: "San Diego", code: "30302" },
          { name: "San Juan", code: "30303" },
          { name: "San Rafael", code: "30304" },
          { name: "Concepción", code: "30305" },
          { name: "Dulce Nombre", code: "30306" },
          { name: "San Ramón", code: "30307" },
          { name: "Río Azul", code: "30308" },
        ],
      },
      {
        name: "Oreamuno",
        code: "307",
        districts: [
          { name: "San Rafael", code: "30701" },
          { name: "Cot", code: "30702" },
          { name: "Potrero Cerrado", code: "30703" },
          { name: "Cipreses", code: "30704" },
          { name: "Santa Rosa", code: "30705" },
        ],
      },
      {
        name: "Paraíso",
        code: "302",
        districts: [
          { name: "Paraíso", code: "30201" },
          { name: "Santiago", code: "30202" },
          { name: "Orosi", code: "30203" },
          { name: "Cachí", code: "30204" },
          { name: "Llanos de Santa Lucía", code: "30205" },
        ],
      },
      {
        name: "Turrialba",
        code: "305",
        districts: [
          { name: "Turrialba", code: "30501" },
          { name: "La Suiza", code: "30502" },
          { name: "Peralta", code: "30503" },
          { name: "Santa Cruz", code: "30504" },
          { name: "Santa Teresita", code: "30505" },
          { name: "Pavones", code: "30506" },
          { name: "Tuis", code: "30507" },
          { name: "Tayutic", code: "30508" },
          { name: "Santa Rosa", code: "30509" },
          { name: "Tres Equis", code: "30510" },
          { name: "La Isabel", code: "30511" },
          { name: "Chirripó", code: "30512" },
        ],
      },
    ],
  },
  {
    name: "Guanacaste",
    code: "5",
    flag: "/assets/images/flags/Guanacaste.png",
    cantons: [
      {
        name: "Abangares",
        code: "507",
        districts: [
          { name: "Las Juntas", code: "50701" },
          { name: "Sierra", code: "50702" },
          { name: "San Juan", code: "50703" },
          { name: "Colorado", code: "50704" },
        ],
      },
      {
        name: "Bagaces",
        code: "503",
        districts: [
          { name: "Bagaces", code: "50301" },
          { name: "La Fortuna", code: "50302" },
          { name: "Mogote", code: "50303" },
          { name: "Río Naranjo", code: "50304" },
        ],
      },
      {
        name: "Cañas",
        code: "506",
        districts: [
          { name: "Cañas", code: "50601" },
          { name: "Palmira", code: "50602" },
          { name: "San Miguel", code: "50603" },
          { name: "Bebedero", code: "50604" },
          { name: "Porozal", code: "50605" },
        ],
      },
      {
        name: "Carrillo",
        code: "505",
        districts: [
          { name: "Filadelfia", code: "50501" },
          { name: "Palmira", code: "50502" },
          { name: "Sardinal", code: "50503" },
          { name: "Belén", code: "50504" },
        ],
      },
      {
        name: "Hojancha",
        code: "511",
        districts: [
          { name: "Hojancha", code: "51101" },
          { name: "Monte Romo", code: "51102" },
          { name: "Puerto Carrillo", code: "51103" },
          { name: "Huacas", code: "51104" },
          { name: "Matambú", code: "51105" },
        ],
      },
      {
        name: "La Cruz",
        code: "510",
        districts: [
          { name: "La Cruz", code: "51001" },
          { name: "Santa Cecilia", code: "51002" },
          { name: "La Garita", code: "51003" },
          { name: "Santa Elena", code: "51004" },
        ],
      },
      {
        name: "Liberia",
        code: "501",
        districts: [
          { name: "Liberia", code: "50101" },
          { name: "Cañas Dulces", code: "50102" },
          { name: "Mayorga", code: "50103" },
          { name: "Nacascolo", code: "50104" },
          { name: "Curubandé", code: "50105" },
        ],
      },
      {
        name: "Nandayure",
        code: "509",
        districts: [
          { name: "Carmona", code: "50901" },
          { name: "Santa Rita", code: "50902" },
          { name: "Zapotal", code: "50903" },
          { name: "San Pablo", code: "50904" },
          { name: "Porvenir", code: "50905" },
          { name: "Bejuco", code: "50906" },
        ],
      },
      {
        name: "Nicoya",
        code: "502",
        districts: [
          { name: "Nicoya", code: "50201" },
          { name: "Mansión", code: "50202" },
          { name: "San Antonio", code: "50203" },
          { name: "Quebrada Honda", code: "50204" },
          { name: "Sámara", code: "50205" },
          { name: "Nosara", code: "50206" },
          { name: "Belén de Nosarita", code: "50207" },
        ],
      },
      {
        name: "Santa Cruz",
        code: "504",
        districts: [
          { name: "Santa Cruz", code: "50401" },
          { name: "Bolsón", code: "50402" },
          { name: "Veintisiete de Abril", code: "50403" },
          { name: "Tempate", code: "50404" },
          { name: "Cartagena", code: "50405" },
          { name: "Cuajiniquil", code: "50406" },
          { name: "Diriá", code: "50407" },
          { name: "Cabo Velas", code: "50408" },
          { name: "Tamarindo", code: "50409" },
        ],
      },
      {
        name: "Tilarán",
        code: "508",
        districts: [
          { name: "Tilarán", code: "50801" },
          { name: "Quebrada Grande", code: "50802" },
          { name: "Tronadora", code: "50803" },
          { name: "Santa Rosa", code: "50804" },
          { name: "Líbano", code: "50805" },
          { name: "Tierras Morenas", code: "50806" },
          { name: "Arenal", code: "50807" },
        ],
      },
    ],
  },
  {
    name: "Heredia",
    code: "4",
    flag: "/assets/images/flags/Heredia.png",
    cantons: [
      {
        name: "Barva",
        code: "402",
        districts: [
          { name: "Barva", code: "40201" },
          { name: "San Pedro", code: "40202" },
          { name: "San Pablo", code: "40203" },
          { name: "San Roque", code: "40204" },
          { name: "Santa Lucía", code: "40205" },
          { name: "San José de la Montaña", code: "40206" },
        ],
      },
      {
        name: "Belén",
        code: "407",
        districts: [
          { name: "San Antonio", code: "40701" },
          { name: "La Ribera", code: "40702" },
          { name: "La Asunción", code: "40703" },
        ],
      },
      {
        name: "Flores",
        code: "408",
        districts: [
          { name: "San Joaquín", code: "40801" },
          { name: "Barrantes", code: "40802" },
          { name: "Llorente", code: "40803" },
        ],
      },
      {
        name: "Heredia",
        code: "401",
        districts: [
          { name: "Heredia", code: "40101" },
          { name: "Mercedes", code: "40102" },
          { name: "San Francisco", code: "40103" },
          { name: "Ulloa", code: "40104" },
          { name: "Varablanca", code: "40105" },
        ],
      },
      {
        name: "San Isidro",
        code: "403",
        districts: [
          { name: "San Isidro", code: "40301" },
          { name: "San José", code: "40302" },
          { name: "Concepción", code: "40303" },
          { name: "San Francisco", code: "40304" },
        ],
      },
      {
        name: "San Pablo",
        code: "409",
        districts: [
          { name: "San Pablo", code: "40901" },
          { name: "Rincón de Sabanilla", code: "40902" },
        ],
      },
      {
        name: "San Rafael",
        code: "405",
        districts: [
          { name: "San Rafael", code: "40501" },
          { name: "San Josecito", code: "40502" },
          { name: "Santiago", code: "40503" },
          { name: "Ángeles", code: "40504" },
          { name: "Concepción", code: "40505" },
        ],
      },
      {
        name: "Santa Bárbara",
        code: "404",
        districts: [
          { name: "Santa Bárbara", code: "40401" },
          { name: "San Pedro", code: "40402" },
          { name: "San Juan", code: "40403" },
          { name: "Jesús", code: "40404" },
          { name: "Santo Domingo", code: "40405" },
          { name: "Purabá", code: "40406" },
        ],
      },
      {
        name: "Santo Domingo",
        code: "406",
        districts: [
          { name: "Santo Domingo", code: "40601" },
          { name: "San Vicente", code: "40602" },
          { name: "San Miguel", code: "40603" },
          { name: "Paracito", code: "40604" },
          { name: "Santo Tomás", code: "40605" },
          { name: "Santa Rosa", code: "40606" },
          { name: "Tures", code: "40607" },
          { name: "Pará", code: "40608" },
        ],
      },
      {
        name: "Sarapiquí",
        code: "410",
        districts: [
          { name: "Puerto Viejo", code: "41001" },
          { name: "La Virgen", code: "41002" },
          { name: "Las Horquetas", code: "41003" },
          { name: "Llanuras del Gaspar", code: "41004" },
          { name: "Cureña", code: "41005" },
        ],
      },
    ],
  },
  {
    name: "Limón",
    code: "7",
    flag: "/assets/images/flags/Limon.png",
    cantons: [
      {
        name: "Guácimo",
        code: "706",
        districts: [
          { name: "Guácimo", code: "70601" },
          { name: "Mercedes", code: "70602" },
          { name: "Pocora", code: "70603" },
          { name: "Río Jiménez", code: "70604" },
          { name: "Duacarí", code: "70605" },
        ],
      },
      {
        name: "Limón",
        code: "701",
        districts: [
          { name: "Limón", code: "70101" },
          { name: "Valle La Estrella", code: "70102" },
          { name: "Río Blanco", code: "70103" },
          { name: "Matama", code: "70104" },
        ],
      },
      {
        name: "Matina",
        code: "704",
        districts: [
          { name: "Matina", code: "70401" },
          { name: "Batán", code: "70402" },
          { name: "Carrandi", code: "70403" },
        ],
      },
      {
        name: "Pococí",
        code: "702",
        districts: [
          { name: "Guápiles", code: "70201" },
          { name: "Jiménez", code: "70202" },
          { name: "Rita", code: "70203" },
          { name: "Roxana", code: "70204" },
          { name: "Cariari", code: "70205" },
          { name: "Colorado", code: "70206" },
          { name: "La Colonia", code: "70207" },
        ],
      },
      {
        name: "Siquirres",
        code: "703",
        districts: [
          { name: "Siquirres", code: "70301" },
          { name: "Pacuarito", code: "70302" },
          { name: "Florida", code: "70303" },
          { name: "Germania", code: "70304" },
          { name: "El Cairo", code: "70305" },
          { name: "Alegría", code: "70306" },
          { name: "Reventazón", code: "70307" },
        ],
      },
      {
        name: "Talamanca",
        code: "705",
        districts: [
          { name: "Bratsi", code: "70501" },
          { name: "Sixaola", code: "70502" },
          { name: "Cahuita", code: "70503" },
          { name: "Telire", code: "70504" },
        ],
      },
    ],
  },
  {
    name: "Puntarenas",
    code: "6",
    flag: "/assets/images/flags/Puntarenas.png",
    cantons: [
      {
        name: "Buenos Aires",
        code: "603",
        districts: [
          { name: "Buenos Aires", code: "60301" },
          { name: "Volcán", code: "60302" },
          { name: "Potrero Grande", code: "60303" },
          { name: "Boruca", code: "60304" },
          { name: "Pilas", code: "60305" },
          { name: "Colinas", code: "60306" },
          { name: "Chánguena", code: "60307" },
          { name: "Biolley", code: "60308" },
          { name: "Brunka", code: "60309" },
        ],
      },
      {
        name: "Coto Brus",
        code: "608",
        districts: [
          { name: "San Vito", code: "60801" },
          { name: "Sabalito", code: "60802" },
          { name: "Aguabuena", code: "60803" },
          { name: "Limoncito", code: "60804" },
          { name: "Pittier", code: "60805" },
          { name: "Gutiérrez Braun", code: "60806" },
        ],
      },
      {
        name: "Corredores",
        code: "610",
        districts: [
          { name: "Corredor", code: "61001" },
          { name: "La Cuesta", code: "61002" },
          { name: "Canoas", code: "61003" },
          { name: "Laurel", code: "61004" },
        ],
      },
      {
        name: "Esparza",
        code: "602",
        districts: [
          { name: "Espíritu Santo", code: "60201" },
          { name: "San Juan Grande", code: "60202" },
          { name: "Macacona", code: "60203" },
          { name: "San Rafael", code: "60204" },
          { name: "San Jerónimo", code: "60205" },
          { name: "Caldera", code: "60206" },
        ],
      },
      {
        name: "Garabito",
        code: "611",
        districts: [
          { name: "Jacó", code: "61101" },
          { name: "Tárcoles", code: "61102" },
        ],
      },
      {
        name: "Golfito",
        code: "607",
        districts: [
          { name: "Golfito", code: "60701" },
          { name: "Puerto Jiménez", code: "60702" },
          { name: "Guaycará", code: "60703" },
          { name: "Pavón", code: "60704" },
        ],
      },
      {
        name: "Monteverde",
        code: "612",
        districts: [
          { name: "Monteverde", code: "61201" },
        ],
      },
      {
        name: "Montes de Oro",
        code: "604",
        districts: [
          { name: "Miramar", code: "60401" },
          { name: "La Unión", code: "60402" },
          { name: "San Isidro", code: "60403" },
        ],
      },
      {
        name: "Osa",
        code: "605",
        districts: [
          { name: "Puerto Cortés", code: "60501" },
          { name: "Palmar", code: "60502" },
          { name: "Sierpe", code: "60503" },
          { name: "Bahía Ballena", code: "60504" },
          { name: "Piedras Blancas", code: "60505" },
          { name: "Bahía Drake", code: "60506" },
        ],
      },
      {
        name: "Parrita",
        code: "609",
        districts: [
          { name: "Parrita", code: "60901" },
        ],
      },
      {
        name: "Puntarenas",
        code: "601",
        districts: [
          { name: "Puntarenas", code: "60101" },
          { name: "Pitahaya", code: "60102" },
          { name: "Chomes", code: "60103" },
          { name: "Lepanto", code: "60104" },
          { name: "Paquera", code: "60105" },
          { name: "Manzanillo", code: "60106" },
          { name: "Guacimal", code: "60107" },
          { name: "Barranca", code: "60108" },
          { name: "Monte Verde", code: "60109" },
          { name: "Isla del Coco", code: "60110" },
          { name: "Cóbano", code: "60111" },
          { name: "Chacarita", code: "60112" },
          { name: "Chira", code: "60113" },
          { name: "Acapulco", code: "60114" },
          { name: "El Roble", code: "60115" },
          { name: "Arancibia", code: "60116" },
        ],
      },
      {
        name: "Puerto Jiménez",
        code: "607",
        districts: [
          { name: "Puerto Jiménez", code: "60702" },
        ],
      },
      {
        name: "Quepos",
        code: "606",
        districts: [
          { name: "Quepos", code: "60601" },
          { name: "Savegre", code: "60602" },
          { name: "Naranjito", code: "60603" },
        ],
      },
    ],
  },
  {
    name: "San José",
    code: "1",
    flag: "/assets/images/flags/SanJose.png",
    cantons: [
      {
        name: "Acosta",
        code: "112",
        districts: [
          { name: "San Ignacio", code: "11201" },
          { name: "Guaitil", code: "11202" },
          { name: "Palmichal", code: "11203" },
          { name: "Cangrejal", code: "11204" },
          { name: "Sabanillas", code: "11205" },
        ],
      },
      {
        name: "Aserrí",
        code: "106",
        districts: [
          { name: "Aserrí", code: "10601" },
          { name: "Tarbaca", code: "10602" },
          { name: "Vuelta de Jorco", code: "10603" },
          { name: "San Gabriel", code: "10604" },
          { name: "Legua", code: "10605" },
          { name: "Monterrey", code: "10606" },
          { name: "Salitrillos", code: "10607" },
        ],
      },
      {
        name: "Desamparados",
        code: "103",
        districts: [
          { name: "Desamparados", code: "10301" },
          { name: "San Miguel", code: "10302" },
          { name: "San Juan de Dios", code: "10303" },
          { name: "San Rafael Arriba", code: "10304" },
          { name: "San Antonio", code: "10305" },
          { name: "Frailes", code: "10306" },
          { name: "Patarrá", code: "10307" },
          { name: "San Cristóbal", code: "10308" },
          { name: "Rosario", code: "10309" },
          { name: "Damas", code: "10310" },
          { name: "San Rafael Abajo", code: "10311" },
          { name: "Gravilias", code: "10312" },
          { name: "Los Guido", code: "10313" },
        ],
      },
      {
        name: "Dota",
        code: "117",
        districts: [
          { name: "Santa María", code: "11701" },
          { name: "Jardín", code: "11702" },
          { name: "Copey", code: "11703" },
        ],
      },
      {
        name: "Escazú",
        code: "102",
        districts: [
          { name: "Escazú", code: "10201" },
          { name: "San Antonio", code: "10202" },
          { name: "San Rafael", code: "10203" },
        ],
      },
      {
        name: "Goicoechea",
        code: "108",
        districts: [
          { name: "Guadalupe", code: "10801" },
          { name: "San Francisco", code: "10802" },
          { name: "Calle Blancos", code: "10803" },
          { name: "Mata de Plátano", code: "10804" },
          { name: "Ipís", code: "10805" },
          { name: "Rancho Redondo", code: "10806" },
          { name: "Purral", code: "10807" },
        ],
      },
      {
        name: "León Cortés Castro",
        code: "119",
        districts: [
          { name: "San Pablo", code: "11901" },
          { name: "San Andrés", code: "11902" },
          { name: "Llano Bonito", code: "11903" },
          { name: "San Isidro", code: "11904" },
          { name: "Santa Cruz", code: "11905" },
          { name: "San Antonio", code: "11906" },
        ],
      },
      {
        name: "Mora",
        code: "107",
        districts: [
          { name: "Colón", code: "10701" },
          { name: "Guayabo", code: "10702" },
          { name: "Tabarcia", code: "10703" },
          { name: "Piedras Negras", code: "10704" },
          { name: "Picagres", code: "10705" },
          { name: "Jaris", code: "10706" },
          { name: "Quitirrisí", code: "10707" },
        ],
      },
      {
        name: "Moravia",
        code: "114",
        districts: [
          { name: "San Vicente", code: "11401" },
          { name: "San Jerónimo", code: "11402" },
          { name: "La Trinidad", code: "11403" },
        ],
      },
      {
        name: "Montes de Oca",
        code: "115",
        districts: [
          { name: "San Pedro", code: "11501" },
          { name: "Sabanilla", code: "11502" },
          { name: "Mercedes", code: "11503" },
          { name: "San Rafael", code: "11504" },
        ],
      },
      {
        name: "Puriscal",
        code: "104",
        districts: [
          { name: "Santiago", code: "10401" },
          { name: "Mercedes Sur", code: "10402" },
          { name: "Barbacoas", code: "10403" },
          { name: "Grifo Alto", code: "10404" },
          { name: "San Rafael", code: "10405" },
          { name: "Candelarita", code: "10406" },
          { name: "Desamparaditos", code: "10407" },
          { name: "San Antonio", code: "10408" },
          { name: "Chires", code: "10409" },
        ],
      },
      {
        name: "Pérez Zeledón",
        code: "119",
        districts: [
          { name: "San Isidro de El General", code: "11901" },
          { name: "El General", code: "11902" },
          { name: "Daniel Flores", code: "11903" },
          { name: "Rivas", code: "11904" },
          { name: "San Pedro", code: "11905" },
          { name: "Platanares", code: "11906" },
          { name: "Pejibaye", code: "11907" },
          { name: "Cajón", code: "11908" },
          { name: "Barú", code: "11909" },
          { name: "Río Nuevo", code: "11910" },
          { name: "Páramo", code: "11911" },
          { name: "La Amistad", code: "11912" },
        ],
      },
      {
        name: "San José",
        code: "101",
        districts: [
          { name: "Carmen", code: "10101" },
          { name: "Merced", code: "10102" },
          { name: "Hospital", code: "10103" },
          { name: "Catedral", code: "10104" },
          { name: "Zapote", code: "10105" },
          { name: "San Francisco de Dos Ríos", code: "10106" },
          { name: "Uruca", code: "10107" },
          { name: "Mata Redonda", code: "10108" },
          { name: "Pavas", code: "10109" },
          { name: "Hatillo", code: "10110" },
          { name: "San Sebastián", code: "10111" },
        ],
      },
      {
        name: "Santa Ana",
        code: "109",
        districts: [
          { name: "Santa Ana", code: "10901" },
          { name: "Salitral", code: "10902" },
          { name: "Pozos", code: "10903" },
          { name: "Uruca", code: "10904" },
          { name: "Piedades", code: "10905" },
          { name: "Brasil", code: "10906" },
        ],
      },
      {
        name: "Tibás",
        code: "113",
        districts: [
          { name: "San Juan", code: "11301" },
          { name: "Cinco Esquinas", code: "11302" },
          { name: "Anselmo Llorente", code: "11303" },
          { name: "León XIII", code: "11304" },
          { name: "Colima", code: "11305" },
        ],
      },
      {
        name: "Tarrazú",
        code: "105",
        districts: [
          { name: "San Marcos", code: "10501" },
          { name: "San Lorenzo", code: "10502" },
          { name: "San Carlos", code: "10503" },
        ],
      },
      {
        name: "Turrubares",
        code: "116",
        districts: [
          { name: "San Pablo", code: "11601" },
          { name: "San Pedro", code: "11602" },
          { name: "San Juan de Mata", code: "11603" },
          { name: "San Luis", code: "11604" },
          { name: "Carara", code: "11605" },
        ],
      },
      {
        name: "Vázquez de Coronado",
        code: "111",
        districts: [
          { name: "San Isidro", code: "11101" },
          { name: "San Rafael", code: "11102" },
          { name: "Dulce Nombre de Jesús", code: "11103" },
          { name: "Patalillo", code: "11104" },
          { name: "Cascajal", code: "11105" },
        ],
      },
    ],
  },
]

export const zoneMapping: Record<ZoneKey, string[]> = {
  "Noroeste (GAM)": [
    "San José-Santa Ana", 
    "Alajuela-Alajuela", 
    "Heredia-Belén",
    "Alajuela-Atenas",
    "Alajuela-Grecia",
    "Alajuela-Naranjo",
    "Alajuela-Palmares",
    "Alajuela-Poás",
    "Alajuela-Valverde Vega",
    "Heredia-Flores",
    "Heredia-Santa Bárbara"
  ],
  "Noreste (GAM)": [
    "San José-Montes de Oca", 
    "San José-Goicoechea", 
    "Cartago-La Unión", 
    "Heredia-Heredia",
    "San José-Vázquez de Coronado",
    "San José-Curridabat",
    "Heredia-San Pablo",
    "Heredia-San Rafael",
    "Heredia-San Isidro",
    "Heredia-Santo Domingo",
    "Heredia-Barva"
  ],
  "Suroeste (GAM)": [
    "San José-Escazú", 
    "San José-Mora",
    "San José-Alajuelita",
    "San José-Santa Ana"
  ],
  "Sureste (GAM)": [
    "San José-San José", 
    "San José-Desamparados", 
    "Cartago-Cartago",
    "San José-Aserrí",
    "Cartago-Paraíso"
  ],
  "Norte (Fuera del GAM)": [
    "Alajuela-San Carlos", 
    "Heredia-Sarapiquí", 
    "Alajuela-Upala",
    "Alajuela-Guatuso",
    "Alajuela-Los Chiles",
    "Alajuela-Río Cuarto",
    "Alajuela-Zarcero"
  ],
  "Sur (Fuera del GAM)": [
    "San José-Pérez Zeledón", 
    "Puntarenas-Buenos Aires", 
    "Puntarenas-Osa",
    "Puntarenas-Coto Brus",
    "Puntarenas-Corredores",
    "Puntarenas-Golfito",
    "San José-Dota",
    "San José-León Cortés Castro",
    "San José-Tarrazú"
  ],
  "Oeste (Fuera del GAM)": [
    "Puntarenas-Puntarenas", 
    "Puntarenas-Esparza",
    "Puntarenas-Montes de Oro",
    "Puntarenas-Garabito",
    "Puntarenas-Parrita",
    "Puntarenas-Quepos",
    "Puntarenas-Monteverde",
    "Alajuela-San Mateo",
    "Alajuela-Orotina",
    "San José-Puriscal",
    "San José-Turrubares",
    "Guanacaste-Liberia",
    "Guanacaste-Nicoya",
    "Guanacaste-Santa Cruz",
    "Guanacaste-Bagaces",
    "Guanacaste-Carrillo",
    "Guanacaste-Cañas",
    "Guanacaste-Abangares",
    "Guanacaste-Tilarán",
    "Guanacaste-Nandayure",
    "Guanacaste-La Cruz",
    "Guanacaste-Hojancha"
  ],
  "Este (Fuera del GAM)": [
    "Cartago-Turrialba", 
    "Limón-Limón",
    "Cartago-Jiménez",
    "Cartago-Alvarado",
    "Cartago-Oreamuno",
    "Cartago-El Guarco",
    "Limón-Pococí",
    "Limón-Siquirres",
    "Limón-Talamanca",
    "Limón-Matina",
    "Limón-Guácimo"
  ],
  "GAM": [
    "San José-San José",
    "San José-Escazú",
    "San José-Desamparados",
    "San José-Aserrí",
    "San José-Alajuelita",
    "San José-Vázquez de Coronado",
    "San José-Goicoechea",
    "San José-Montes de Oca",
    "San José-Curridabat",
    "San José-Santa Ana",
    "San José-Mora",
    "Alajuela-Alajuela",
    "Alajuela-Grecia",
    "Alajuela-Atenas",
    "Alajuela-Naranjo",
    "Alajuela-Palmares",
    "Alajuela-Poás",
    "Alajuela-Valverde Vega",
    "Heredia-Heredia",
    "Heredia-San Pablo",
    "Heredia-San Rafael",
    "Heredia-San Isidro",
    "Heredia-Belén",
    "Heredia-Flores",
    "Heredia-Santo Domingo",
    "Heredia-Barva",
    "Heredia-Santa Bárbara",
    "Cartago-Cartago",
    "Cartago-La Unión",
    "Cartago-Paraíso"
  ],
  "Zona Desconocida": [],
}
export const zoneIcons: Record<ZoneKey, string> = {
  "Noroeste (GAM)": "↖️",
  "Noreste (GAM)": "↗️",
  "Suroeste (GAM)": "↙️",
  "Sureste (GAM)": "↘️",
  "Norte (Fuera del GAM)": "⬆️",
  "Sur (Fuera del GAM)": "⬇️",
  "Oeste (Fuera del GAM)": "⬅️",
  "Este (Fuera del GAM)": "➡️",
  GAM: "🏙️",
  "Zona Desconocida": "❓",
}

// Función para obtener todos los distritos de un cantón
export const getDistrictsByCanton = (provinceCode: string, cantonCode: string): District[] => {
  const province = provinces.find(p => p.code === provinceCode)
  if (!province) return []
  
  const canton = province.cantons.find(c => c.code === cantonCode)
  if (!canton) return []
  
  return canton.districts
}

// Función para obtener todos los cantones de una provincia
export const getCantonsByProvince = (provinceCode: string): Canton[] => {
  const province = provinces.find(p => p.code === provinceCode)
  if (!province) return []
  
  return province.cantons
}

// Función para obtener la zona de una ubicación
export const getZoneByLocation = (province: string, canton: string): ZoneKey => {
  const locationKey = `${province}-${canton}`
  
  for (const [zone, locations] of Object.entries(zoneMapping)) {
    if (locations.includes(locationKey)) {
      return zone as ZoneKey
    }
  }
  
  // Verificar si está en el GAM (simplificado)
  const gamProvinces = ["San José", "Alajuela", "Heredia", "Cartago"]
  if (gamProvinces.includes(province)) {
    return "GAM"
  }
  
  return "Zona Desconocida"
}
export {}